import React from 'react';
import s from './s.module.less';
import Icon from './icon.png';
import { Button } from 'antd';
import AuthButton from '../AuthButton';
import { Event } from 'types/calendar';
import { KlarityService } from 'types/common';
import { getEventTitleDisplay } from 'utils/calendar';

type Props = {
    event?: Event;
    allSpecialityData?: KlarityService[];
};

const EventTitle = (props: Props) => {
    const { event, allSpecialityData } = props;
    const text = getEventTitleDisplay(event);
    const targetSpeciality = allSpecialityData?.find((item) => item.specialtyName === event?.serviceSpecialty);
    return (
        <div className={s.wrap}>
            {/* {
                event?.isSample ? '[Sample]' : ''
            } */}
            {
                targetSpeciality && (
                    <img className={s.speIcon} src={targetSpeciality.iconUrl} alt="" />
                )
            }
            {text || 'No title'}
        </div>
    );
};

export default EventTitle;
